<template>
  <main class="paybill-pay-mobile">
    <section class="paybill-card" aria-labelledby="paybill-title">
      <header class="paybill-header">
        <div class="paybill-mark">M</div>
        <div>
          <h1 id="paybill-title">M-Pesa PayBill</h1>
          <p>Complete this repayment from your M-Pesa menu.</p>
        </div>
      </header>

      <div class="amount-block">
        <span>Amount</span>
        <strong>{{ currencyCode }} {{ amount }}</strong>
      </div>

      <div class="payment-details">
        <div class="payment-detail">
          <div>
            <span>PayBill Number</span>
            <strong>{{ shortCode || '--' }}</strong>
          </div>
          <button type="button" title="Copy PayBill number" aria-label="Copy PayBill number" @click="onCopy(shortCode)">
            <img src="@/assets/copy.png" alt="" />
          </button>
        </div>
        <div class="payment-detail">
          <div>
            <span>Bill Reference</span>
            <strong>{{ billReference }}</strong>
          </div>
          <button type="button" title="Copy Bill Reference" aria-label="Copy Bill Reference" @click="onCopy(billReference)">
            <img src="@/assets/copy.png" alt="" />
          </button>
        </div>
      </div>

      <ol class="instructions">
        <li>Open M-Pesa and choose <b>Lipa na M-Pesa</b>, then <b>PayBill</b>.</li>
        <li>Enter the PayBill Number and Bill Reference shown above.</li>
        <li>Confirm the amount and complete payment on your phone.</li>
      </ol>

      <div class="waiting-state">
        <span></span>
        Waiting for your payment. This page updates automatically.
      </div>
      <div v-if="hr !== undefined" class="timer">Time remaining: {{ hr }}:{{ min }}:{{ sec }}</div>
    </section>
  </main>
</template>

<script>
import logic from "./index.js";

export default {
  name: "SafaricomPayBillMoblie",
  mixins: [logic],
};
</script>

<style lang="scss" scoped>
.paybill-pay-mobile {
  background: #f5f8f6;
  min-height: 100vh;
  padding: 24px 16px;
}

.paybill-card {
  background: #fff;
  border: 1px solid #e4e8e5;
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(34, 58, 45, 0.07);
  padding: 20px;
}

.paybill-header {
  align-items: center;
  display: flex;
  gap: 10px;
  margin-bottom: 20px;

  h1 {
    color: #183d2b;
    font-size: 18px;
    margin: 0;
  }

  p {
    color: #718077;
    font-size: 12px;
    line-height: 1.4;
    margin: 4px 0 0;
  }
}

.paybill-mark {
  align-items: center;
  background: #2f9d57;
  border-radius: 50%;
  color: #fff;
  display: flex;
  flex: 0 0 36px;
  font-size: 17px;
  font-weight: 700;
  height: 36px;
  justify-content: center;
}

.amount-block {
  background: #f6faf7;
  border: 1px solid #e1ece4;
  padding: 14px;
  text-align: center;

  span, strong {
    display: block;
  }

  span {
    color: #718077;
    font-size: 12px;
  }

  strong {
    color: #183d2b;
    font-size: 20px;
    margin-top: 4px;
  }
}

.payment-details {
  border: 1px solid #e4e8e5;
  margin-top: 16px;
}

.payment-detail {
  align-items: center;
  border-bottom: 1px solid #e4e8e5;
  display: flex;
  justify-content: space-between;
  padding: 14px;

  &:last-child {
    border-bottom: 0;
  }

  div {
    min-width: 0;
  }

  span, strong {
    display: block;
  }

  span {
    color: #718077;
    font-size: 11px;
  }

  strong {
    color: #183d2b;
    font-size: 14px;
    margin-top: 5px;
    overflow-wrap: anywhere;
  }

  button {
    align-items: center;
    background: transparent;
    border: 0;
    display: flex;
    flex: 0 0 32px;
    height: 32px;
    justify-content: center;
    margin-left: 8px;
    padding: 6px;
  }

  button:active {
    background: #edf6ef;
  }

  img {
    height: 18px;
    width: 18px;
  }
}

.instructions {
  color: #4d5b52;
  font-size: 12px;
  line-height: 1.55;
  margin: 18px 0;
  padding-left: 18px;

  li + li {
    margin-top: 6px;
  }
}

.waiting-state {
  align-items: flex-start;
  color: #417052;
  display: flex;
  font-size: 12px;
  gap: 8px;
  line-height: 1.4;
}

.waiting-state span {
  animation: pulse 1.5s ease-in-out infinite;
  background: #2f9d57;
  border-radius: 50%;
  flex: 0 0 8px;
  height: 8px;
  margin-top: 4px;
}

.timer {
  color: #718077;
  font-size: 12px;
  margin-top: 12px;
  text-align: center;
}

@keyframes pulse {
  50% { opacity: 0.35; }
}
</style>
